import React from 'react';
import { toast } from 'react-toastify';

export function CopyRendererComponent({ data }: any) {
  const handleCopied = () => {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = data.Url;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    toast.info('Copied');
  };

  return (
    <div className="flex justify-center items-center">
      <button
        onClick={handleCopied}
        className="text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 rounded-full p-2"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <path d="M2 4.5A1.5 1.5 0 0 1 3.5 3h5.086a1.5 1.5 0 0 1 1.06.44l1.414 1.414a1.5 1.5 0 0 0 1.06.44H20.5A1.5 1.5 0 0 1 22 6.5v11A1.5 1.5 0 0 1 20.5 19h-17A1.5 1.5 0 0 1 2 17.5v-13z" />
          <path d="M2.25 8.75A.75.75 0 0 1 3 8h18a.75.75 0 0 1 .75.75v9.5a.75.75 0 0 1-.75.75h-18a.75.75 0 0 1-.75-.75v-9.5z" />
        </svg>
      </button>
    </div>
  );
}